import HSPinInput from './PasscodeInput.plugin';
import { useEffect, useState } from 'react';
import styles from './PasscodeInput.module.scss';

export interface PasscodeInputProps {
  onCompleted?: (value: string) => void;
  onChange?: (value: string) => void;
  hasError?: boolean;
}

export function PasscodeInput({ onCompleted, onChange, hasError = false }: PasscodeInputProps) {
  const [values, setValues] = useState<string[]>(['', '', '', '']);

  useEffect(() => {
    HSPinInput.autoInit();
  }, []);

  useEffect(() => {
    if (onChange) {
      onChange(values.map((v) => (v === '' ? ' ' : v)).join(''));
    }

    if (onCompleted && values.every((v) => v || v === '0')) {
      onCompleted(values.join(''));
    }
  }, [values]);

  const handleInput = (value: string, index: number) => {
    setValues((prev) => {
      return prev.map((v, i) => {
        if (i === index) {
          return value;
        }
        return v;
      });
    });
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>, index: number) => {
    if (e.key === 'Backspace') {
      const idx = values[index] ? index : Math.max(index - 1, 0);
      setValues((prev) => {
        return prev.map((v, i) => {
          if (i === idx) {
            return '';
          }
          return v;
        });
      });
    }
  };

  return (
    <div
      className={`flex gap-x-3 ${styles.passcode_input_container} ${hasError && styles.has_error}`}
      data-hs-pin-input={`{ "availableCharsRE": "^[0-9]+$" }`}
    >
      <input
        type="password"
        className="block w-[38px] text-center bg-transparent border-t-transparent border-x-transparent border-b-transparent text-sm focus:border-t-transparent focus:border-x-transparent focus:border-b-neutral-500 focus:ring-0 disabled:opacity-50 disabled:pointer-events-none dark:border-b-transparent dark:text-neutral-400  dark:placeholder-neutral-500 dark:focus:ring-neutral-600 dark:focus:border-b-transparent"
        data-hs-pin-input-item=""
        placeholder="⚬"
        onInput={(e) => handleInput((e.target as HTMLInputElement).value, 0)}
        onKeyDown={(e) => handleKeyDown(e, 0)}
        autoComplete={'new-password'}
        autoFocus
      />
      <input
        type="password"
        className="block w-[38px] text-center bg-transparent border-t-transparent border-x-transparent border-b-transparent text-sm focus:border-t-transparent focus:border-x-transparent focus:border-b-transparent focus:ring-0 disabled:opacity-50 disabled:pointer-events-none dark:border-b-transparent dark:text-neutral-400  dark:placeholder-neutral-500 dark:focus:ring-neutral-600 dark:focus:border-b-transparent"
        data-hs-pin-input-item=""
        placeholder="⚬"
        onInput={(e) => handleInput((e.target as HTMLInputElement).value, 1)}
        onKeyDown={(e) => handleKeyDown(e, 1)}
        autoComplete={'new-password'}
      />
      <input
        type="password"
        className="block w-[38px] text-center bg-transparent border-t-transparent border-x-transparent border-b-transparent text-sm focus:border-t-transparent focus:border-x-transparent focus:border-b-transparent focus:ring-0 disabled:opacity-50 disabled:pointer-events-none dark:border-b-transparent dark:text-neutral-400  dark:placeholder-neutral-500 dark:focus:ring-neutral-600 dark:focus:border-b-transparent"
        data-hs-pin-input-item=""
        placeholder="⚬"
        onInput={(e) => handleInput((e.target as HTMLInputElement).value, 2)}
        onKeyDown={(e) => handleKeyDown(e, 2)}
        autoComplete={'new-password'}
      />
      <input
        type="password"
        className="block w-[38px] text-center bg-transparent border-t-transparent border-x-transparent border-b-transparent text-sm focus:border-t-transparent focus:border-x-transparent focus:border-b-transparent focus:ring-0 disabled:opacity-50 disabled:pointer-events-none dark:border-b-transparent dark:text-neutral-400  dark:placeholder-neutral-500 dark:focus:ring-neutral-600 dark:focus:border-b-transparent"
        data-hs-pin-input-item=""
        placeholder="⚬"
        onInput={(e) => handleInput((e.target as HTMLInputElement).value, 3)}
        onKeyDown={(e) => handleKeyDown(e, 3)}
        autoComplete={'new-password'}
      />
    </div>
  );
}
